import { FunctionComponent } from 'preact';

import { usePlayer } from '../../hooks/PlayerProvider';
import { TogglePlayButton } from '../../components/buttons/TogglePlayButton';
import { CloseButton } from '../../components/buttons/CloseButton';
import { PauseAdLink } from '../../components/PauseAdLink/PauseAdLink';

export const PauseAdLayout: FunctionComponent = () => {
  const player = usePlayer();

  const handleClick = () => {
    if (player.getPlugin('PausePlugin')) {
      player.getPlugin('PausePlugin').hide();
      player.trigger('PausePlugin:pauseAdClosed');
    }
  };

  return (
    <div className="vgp-pause-ad-layout">
      <div className="vgp-pause-ad-layout-top">
        <div className="vgp-buttons vgp-pause-ad-button-group">
          <CloseButton onClick={handleClick} variant="square" filled />
        </div>
      </div>
      <div className="vgp-pause-ad-layout-center" />
      <div className="vgp-pause-ad-layout-row">
        <div className="vgp-pause-ad-playback-group">
          <TogglePlayButton
            color="primary"
            filled
            onClick={() => player.play()}
          />
          <PauseAdLink />
        </div>
        <div className="vgp-pause-ad-non-clickable" />
      </div>
    </div>
  );
};
